// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1S75e","info":"PatientInfo_info__2m5rW"};